module.exports = require("@agm/core/services/maps-api-loader/maps-api-loader");